import {HeadFC, PageProps} from "gatsby"
import {Fragment} from "react"
import Blank from "~/components/Sections/Blank/Blank"
import Carousel from "~/components/Sections/Carousel/Carousel"
import HeroSection from "~/components/Sections/HeroSection/HeroSection"
import MultiStyleText from "~/components/UI/MultiStyleText/MultiStyleText"
import RichTextField from "~/components/UI/RichText/RichText"
import ScrollButton from "~/components/UI/ScrollButton/ScrollButton"
import SectionContainer from "~/components/UI/SectionContainer/SectionContainer"
import Spacer from "~/components/UI/Spacer/Spacer"
import VideoPlayer from "~/components/UI/VideoPlayer/VideoPlayer"
import {useLinksQuery} from "~/queries/LinksQuery"
import {SEO} from "../components/UI/SEO/SEO"
import {PageContext} from "../types/PageContext"
import getTextFromHTML from "../utilities/getTextFromHTML"

type ProductsPageContext = PageContext<Queries.ProductsPageQuery["allContentfulPaginaProdotti"]["edges"][0]["node"]>

interface ProductsPageProps extends PageProps<any, ProductsPageContext> {}

const ProductsPage: React.FC<ProductsPageProps> = props => {
    const productsPageData = props.pageContext.data

    return (
        <Fragment>
            <HeroSection
                image={productsPageData.header?.gatsbyImageData}
                imageAlt={productsPageData.header?.title}
                mobileImage={productsPageData.headerMobile?.gatsbyImageData}
            >
                <MultiStyleText flex className1="hero-title-part-1-d2bh" className2="hero-title-part-2-d2bh">
                    {productsPageData.title}
                </MultiStyleText>
            </HeroSection>
            <SectionContainer tabbed marginPost customTab={<ScrollButton />} withFadeInEffect>
                <Blank>
                    {/* <h2 className="no-margin">{productsPageData.title}</h2> */}
                    <RichTextField
                        style={{marginTop: "var(--gutter-5)", marginBottom: "var(--gutter-7)"}}
                        className="font-h6 chars-h6-80"
                    >
                        {productsPageData.paragraph?.raw}
                    </RichTextField>
                </Blank>
            </SectionContainer>
            <SectionContainer>
                <Spacer
                    borderHeight={1}
                    color="gray"
                    backgroundImage={productsPageData.backgroundPart1?.gatsbyImageData}
                    backgroundImageAlt={productsPageData.backgroundPart1?.title}
                />
            </SectionContainer>
            {/* <SectionContainer id="ingaming-advertising">
                <VideoPlayer
                    title={productsPageData.inGamingAdvertising?.title}
                    description={productsPageData.inGamingAdvertising?.descrizioneVideo?.raw}
                    backgroundImage={productsPageData.inGamingAdvertising?.image?.gatsbyImageData}
                    backgroundAlt={productsPageData.inGamingAdvertising?.image?.title}
                    videoSources={{
                        src: productsPageData.inGamingAdvertising?.video?.url,
                        mimeType: productsPageData.inGamingAdvertising?.video?.mimeType,
                    }}
                />
                <Blank>
                    <RichTextField className="font-h6 chars-h6-80">
                        {productsPageData.inGamingAdvertising?.description?.raw}
                    </RichTextField>
                </Blank>
                <ImageSection slides={productsPageData.inGamingAdvertising?.caroselloInGamingVerticale} />
            </SectionContainer>
            <SectionContainer>
                <Spacer
                    borderHeight={1}
                    color="gray"
                    backgroundImage={productsPageData.backgroundPart2?.gatsbyImageData}
                    backgroundImageAlt={productsPageData.backgroundPart2?.title}
                />
            </SectionContainer> */}
            <SectionContainer id="proximity-marketing">
                <VideoPlayer
                    title={productsPageData.proximityMarketing?.title}
                    description={productsPageData.proximityMarketing?.description?.raw}
                    backgroundImage={productsPageData.proximityMarketing?.image?.gatsbyImageData}
                    backgroundAlt={productsPageData.proximityMarketing?.image?.title}
                    videoSources={{
                        src: productsPageData.proximityMarketing?.video?.url,
                        mimeType: productsPageData.proximityMarketing?.video?.mimeType,
                    }}
                />
            </SectionContainer>
            <SectionContainer>
                <Spacer
                    borderHeight={1}
                    color="gray"
                    backgroundImage={productsPageData.backgroundPart3?.gatsbyImageData}
                    backgroundImageAlt={productsPageData.backgroundPart3?.title}
                />
            </SectionContainer>
            <SectionContainer id="creative-formats">
                <Carousel
                    title={productsPageData.formatiCreativi?.title}
                    backgroundImage={productsPageData.formatiCreativi?.image?.gatsbyImageData}
                    backgroundAlt={productsPageData.formatiCreativi?.image?.title}
                >
                    {productsPageData.formatiCreativi?.caroselloFormatiCreativi?.map((slide, index) => {
                        return (
                            <Carousel.Slide
                                key={index}
                                title={slide?.title}
                                description={slide?.description?.raw}
                                video={{
                                    src: slide?.video?.url,
                                    mimeType: slide?.video?.mimeType,
                                }}
                            />
                        )
                    })}
                </Carousel>
            </SectionContainer>
            {/* <SectionContainer>
                <Spacer
                    color="gray"
                    backgroundImage={productsPageData.backgroundPart4?.gatsbyImageData}
                    backgroundImageAlt={productsPageData.backgroundPart4?.title}
                />
            </SectionContainer> */}
            {/* <SectionContainer id="value-network">
                <Carousel
                    title={productsPageData.concessionariaVerticale?.title}
                    backgroundImage={productsPageData.concessionariaVerticale?.image?.gatsbyImageData}
                    backgroundAlt={productsPageData.concessionariaVerticale?.image?.title}
                    noVideo
                >
                    {productsPageData.concessionariaVerticale?.caroselloConcessionariaVerticale?.map((slide, index) => {
                        return (
                            <Carousel.Slide
                                key={index}
                                title={slide?.title}
                                description={slide?.description?.raw}
                                video={{
                                    src: slide?.video?.url,
                                    mimeType: slide?.video?.mimeType,
                                }}
                                ctaName={slide?.ctaName}
                                ctaLink={slide?.ctaLink}
                                chart={slide?.chart}
                                dataList={slide?.dataList}
                            />
                        )
                    })}
                </Carousel>
            </SectionContainer> */}
        </Fragment>
    )
}
export default ProductsPage

export const Head: HeadFC<any, ProductsPageContext> = props => {
    const productsPageData = props.pageContext.data

    const links = useLinksQuery()

    return (
        <SEO
            title={productsPageData.title}
            description={getTextFromHTML(productsPageData.paragraph?.raw)}
            language={props.pageContext.language}
            image={productsPageData.header?.url}
            imageAlt={productsPageData.header?.title}
            siteUrl={`${process.env.SITE_URL}${links.products.url}`}
        />
    )
}
